import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import SoftTokensActivateTokenActivationPage, { getDefaultData } from "components/pages/SoftTokensActivateTokenActivationPage";

/**
 * @name CaptureSoftTokenActivationActivateTokenSignatureEntered
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateTokenSignatureEntered(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "activationSignature" ], { value: "001 695 635 4" })
    .submit();

    return <SoftTokensActivateTokenActivationPage data={ data } />;
}